// bd-deepcontext-4x5yg — URLs-per-run recommendation for the scheduled-job
// forms. The URL-pool estimate divided by the job's daily iteration count,
// rounded to a clean number the user can accept with one click.

// deepcontext-y74t — the backend job runner rejects urlsPerRun above 10,000
// ("Limit must be between 1 and 10000"). The UI must never save or recommend
// past this, so it's the single shared source of truth for the cap.
export const MAX_URLS_PER_RUN = 10000;

/**
 * Round a raw URLs-per-run recommendation to a clean number:
 * nearest 100 at >= 100, nearest 10 below that, minimum 1.
 * e.g. 5000 / 24 = 208.33 -> 200.
 */
export const roundRecommendedUrls = (raw: number): number => {
  if (raw >= 100) return Math.round(raw / 100) * 100;
  return Math.max(1, Math.round(raw / 10) * 10);
};

/**
 * Recommended URLs per run given the topic-eligible pool total and the daily
 * iteration count. Returns null when there is nothing to recommend:
 * empty/unknown pool (total <= 0) or invalid iterations (0, negative, NaN).
 * Never recommends more than MAX_URLS_PER_RUN (a large pool / low runs-per-day
 * can otherwise suggest ~20,000, which the backend would reject).
 */
export const recommendUrlsPerRun = (
  poolTotal: number,
  iterations: number,
): number | null => {
  if (!Number.isFinite(poolTotal) || poolTotal <= 0) return null;
  if (!Number.isFinite(iterations) || iterations <= 0) return null;
  return Math.min(MAX_URLS_PER_RUN, roundRecommendedUrls(poolTotal / iterations));
};
